export function stub<T>(v?: T): T {
  return v
}
